// extracted by mini-css-extract-plugin
export default {"socialShare":"SocialShare_socialShare__WQMug","socials":"SocialShare_socials__LJsJH"};